<script>
import ListForm from '../ListForm.vue'
import * as categoryService from '../../service/category.service';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    ListForm,
  },
  data(){
    return {
      value: null,
      listData: [],
      selectedItem: new Object,
      prevSelectedItem: '{}',
      showListForm: false
}
  },
  computed: {
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x => x.active == true)).length;
    },
    filteredList() {
      let list = this.listData.filter(x => x.additionalProp1 && x.additionalProp1[this.item.filterOn] && x.additionalProp1[this.item.filterOn] == this.value);
      if(list.length) this.setSelectedItems(list[0]);
      else this.setSelectedItems(new Object)
      return list;
    },
  },
  methods: {
    setSelectedItems(val) {
      this.selectedItem = val;
      this.prevSelectedItem = JSON.stringify(val);
      this.setTopbarControls(null, this.listData, this.selectedItem, this.prevSelectedItem)
    },
    updateValue(val) {
      this.value = val;
    },
    async getData() {
      const data = await categoryService.get(this.$route.params.categoryId)
      this.setSelectedItems(data);
    }
  },
  async mounted() {
    await this.getData();
  }
};
</script>
<template>
  <ListForm
      :style="item.style"
      :class="`col-${item.size} ${item.class}`"
      :item="item"
      :items="item.children"
      :selectedItem="selectedItem"
      :listItems="listData"
      :prevSelectedItem="prevSelectedItem"
      :setSelectedItems="setSelectedItems"
      :topbarControls="topbarControls"
  />
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 300px);
   padding-right: 2em;
 }
</style>